import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "split-mode-banner" }
const _hoisted_2 = {
  class: "rtc-hidden-mount",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "text-chat-panel" }
const _hoisted_4 = { class: "text-chat-header" }
const _hoisted_5 = { class: "text-chat-body" }
const _hoisted_6 = {
  ref: "textChatScrollContainer",
  class: "text-chat-messages"
}
const _hoisted_7 = {
  key: 0,
  class: "text-chat-empty"
}
const _hoisted_8 = { class: "text-chat-role" }
const _hoisted_9 = { class: "text-chat-content" }
const _hoisted_10 = { class: "text-chat-input-area" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["src", "alt", "onClick"]
const _hoisted_13 = { class: "image-toast-actions" }
const _hoisted_14 = { class: "preview-container" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPanel = _resolveComponent("VideoPanel")!
  const _component_AvatarPanel = _resolveComponent("AvatarPanel")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_ControlsPanel = _resolveComponent("ControlsPanel")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["connection-manager", { 'portrait-mode': _ctx.isPortraitMode }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-interface", {
        'video-minimized': _ctx.isVideoMinimized,
        portrait: _ctx.isPortraitMode,
        'windows-split': _ctx.isWindowsSplit,
      }])
    }, [
      (!_ctx.isWindowsSplit)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["card-container", { portrait: _ctx.isPortraitMode }])
          }, [
            _withDirectives(_createVNode(_component_VideoPanel, {
              "is-connected": _ctx.isConnected,
              "is-user-speaking": _ctx.isUserSpeaking,
              "is-portrait-mode": _ctx.isPortraitMode,
              onMinimize: _ctx.minimizeVideo
            }, null, 8, ["is-connected", "is-user-speaking", "is-portrait-mode", "onMinimize"]), [
              [_vShow, !_ctx.isVideoMinimized]
            ]),
            _createVNode(_component_AvatarPanel, {
              "full-width": _ctx.isVideoMinimized || _ctx.isPortraitMode,
              "is-agent-speaking": _ctx.isAgentSpeaking,
              "is-agent-thinking": _ctx.isAgentThinking,
              "avatar-image": _ctx.avatarImage
            }, null, 8, ["full-width", "is-agent-speaking", "is-agent-thinking", "avatar-image"])
          ], 2))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_1, [
              _cache[6] || (_cache[6] = _createElementVNode("p", null, "画面与形象已在两个独立浏览器窗口中显示", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "左：摄像头画面 · 右：AI 形象与控制栏 · 本窗口仅保留会话", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "split-restore-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.restoreFromSplit && _ctx.restoreFromSplit(...args)))
              }, " 收回到主界面 ")
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_VideoPanel, {
                "mount-only": "",
                "is-connected": _ctx.isConnected,
                "is-user-speaking": _ctx.isUserSpeaking,
                "is-portrait-mode": false
              }, null, 8, ["is-connected", "is-user-speaking"]),
              _createVNode(_component_AvatarPanel, {
                "full-width": true,
                "is-agent-speaking": _ctx.isAgentSpeaking,
                "is-agent-thinking": _ctx.isAgentThinking,
                "avatar-image": _ctx.avatarImage
              }, null, 8, ["is-agent-speaking", "is-agent-thinking", "avatar-image"])
            ])
          ], 64)),
      _createElementVNode("div", {
        class: _normalizeClass(["status-indicator", _ctx.connectStatus])
      }, _toDisplayString(_ctx.connectStatus === 'connected'
            ? '在线'
            : _ctx.connectStatus === 'reconnecting'
              ? `重连中(${_ctx.reconnectAttempts}/${_ctx.maxReconnectAttempts})`
              : '离线'), 3),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-chat-title" }, [
            _createTextVNode(" 文字聊天 "),
            _createElementVNode("span", { class: "text-chat-hint" }, "Ctrl+Shift+Y 隐藏")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "text-chat-close",
            title: "隐藏 (Ctrl+Shift+Y)",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTextChatPanel && _ctx.hideTextChatPanel(...args)))
          }, " × ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.chatMessages.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 输入文字发送，智能体将语音回答 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatMessages, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${item.role}-${index}-${item.timestamp.getTime()}`,
                class: _normalizeClass(["text-chat-message", item.role])
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.role === 'user' ? '我' : '智能体'), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1)
              ], 2))
            }), 128))
          ], 512),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("textarea", {
              ref: "textChatInputRef",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputMessage) = $event)),
              rows: "2",
              placeholder: "输入文字，Enter 发送，Shift+Enter 换行",
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.sendTextMessage && _ctx.sendTextMessage(...args)), ["exact","prevent"]), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.inputMessage]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "text-chat-send",
              disabled: !_ctx.inputMessage.trim() || !_ctx.isConnected,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendTextMessage && _ctx.sendTextMessage(...args)))
            }, " 发送 ", 8, _hoisted_11)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showTextChatPanel]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadedImages, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: image.originalUrl || image.url || image.timestamp,
          class: "image-download-toast"
        }, [
          _createElementVNode("img", {
            src: image.url,
            alt: 'Downloaded image ' + (index + 1),
            class: "image-thumbnail",
            onClick: ($event: any) => (_ctx.openImagePreview(image.url))
          }, null, 8, _hoisted_12),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "image-toast-content" }, [
            _createElementVNode("p", null, "图片已生成"),
            _createElementVNode("p", { class: "image-toast-hint" }, "点击查看")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_a_button, {
              shape: "circle",
              size: "small",
              onClick: ($event: any) => (_ctx.saveImageToFile(image.url)),
              class: "image-toast-download",
              title: "保存图片"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DownloadOutlined)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              shape: "circle",
              size: "small",
              onClick: ($event: any) => (_ctx.removeImageToast(index)),
              class: "image-toast-close"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseOutlined)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      }), 128)),
      _createVNode(_component_a_modal, {
        open: _ctx.imagePreviewVisible,
        footer: null,
        centered: true,
        width: 'auto',
        "body-style": { padding: '0', textAlign: 'center' },
        onCancel: _ctx.closeImagePreview,
        class: "image-preview-modal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.previewImageUrl,
              alt: "预览图片",
              class: "preview-image"
            }, null, 8, _hoisted_15),
            _createVNode(_component_a_button, {
              class: "preview-download-btn",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveImageToFile(_ctx.previewImageUrl))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DownloadOutlined),
                _cache[10] || (_cache[10] = _createTextVNode(" 保存图片 ", -1))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open", "onCancel"]),
      (!_ctx.isWindowsSplit)
        ? (_openBlock(), _createBlock(_component_ControlsPanel, {
            key: 2,
            "is-connected": _ctx.isConnected,
            "is-connecting": _ctx.isConnecting,
            "is-microphone-muted": _ctx.isMicrophoneMuted,
            "is-volume-muted": _ctx.isVolumeMuted,
            volume: _ctx.volume,
            "is-portrait-mode": _ctx.isPortraitMode,
            onConnect: _ctx.handleConnectClick,
            onDisconnect: _ctx.handleDisconnect,
            onToggleMicrophone: _ctx.handleToggleMicrophone,
            onToggleVolumeMute: _ctx.handleToggleVolumeMute,
            onVolumeChange: _ctx.handleVolumeChange,
            onInterrupt: _ctx.handleInterrupt,
            onSummarize: _ctx.handleSummarize,
            onLogout: _ctx.handleLogout
          }, null, 8, ["is-connected", "is-connecting", "is-microphone-muted", "is-volume-muted", "volume", "is-portrait-mode", "onConnect", "onDisconnect", "onToggleMicrophone", "onToggleVolumeMute", "onVolumeChange", "onInterrupt", "onSummarize", "onLogout"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}